import React from 'react';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';

const ProtectedRoute = ({ authenticated, component: WrappedComponent }) => (
  <Route
    render={(props) => {
      if (authenticated) {
        return (
          <WrappedComponent props />
        );
      }
      return (
        <Redirect to={{ pathname: '/', state: { from: props.location } }} />
      );
    }}
  />
);

ProtectedRoute.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  component:
    PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  location: PropTypes.object.isRequired,
  authenticated: PropTypes.bool,
};

ProtectedRoute.defaultProps = {
  authenticated: false,
};

function mapStateToProps(state) {
  return {
    authenticated: state.authenticated,
  };
}

export default connect(mapStateToProps)(ProtectedRoute);
